// Builds the serverURLMap passed to APIHelper.init().
//
// Maps each ArchistarServerURLMap key to the VUE_APP_* env var that holds its
// URL. AU uses the base VUE_APP_API_URL_* vars; other countries use the
// VUE_APP_<CC>_API_URL_* override where one is defined, falling back to the base.
//
// NOTE: this is a vue-cli/webpack project, so env access is via process.env and
// vars must be prefixed VUE_APP_ (not import.meta.env / VITE_).
const serverUrlEnvKeyMap = {
  API_URL_ADMIN: 'API_URL_ADMIN',
  API_URL_ARCHISTAR: 'API_URL_ARCHISTAR',
  API_URL_GENERATOR: 'API_URL_GENERATOR',
  API_URL_HOMESMGMT: 'API_URL_HOMESMGMT',
  API_URL_PLANNING_CODES: 'API_URL_PLANNING_CODES',
  API_URL_WORKSPACE: 'API_URL_WORKSPACE',
  API_URL_DOCUMENT: 'API_URL_DOCUMENT',
  API_URL_MANAGE: 'API_URL_MANAGE',
  API_URL_ECHECK: 'API_URL_ECHECK_BACKEND',
  API_URL_CITY_MANAGER: 'API_URL_CITY_MANAGER'
};

export const GetCountrySpecificServerURLMap = (countryCode) => {
  const cc = (countryCode || 'au').toLowerCase();
  const ccPrefix = cc === 'au' ? '' : `${cc.toUpperCase()}_`;

  const serverUrlMap = {};
  Object.keys(serverUrlEnvKeyMap).forEach((apiKey) => {
    const envSuffix = serverUrlEnvKeyMap[apiKey];
    // Country override first, base URL as fallback.
    serverUrlMap[apiKey] = process.env[`VUE_APP_${ccPrefix}${envSuffix}`] || process.env[`VUE_APP_${envSuffix}`];
  });

  return serverUrlMap;
};
